<template>
  <div class="bind">
    <h3>Bind Trailer</h3>
    <el-row>
      <el-col :span="5">
        <el-form ref="leftForm" label-width="80px" class="gatewayForm">
          <el-form-item label="NO.">
            <el-input v-model="vehicle_plate" disabled></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="19">
        <el-row>
          <el-col :span="10">
            <el-form ref="headLeftForm" :inline="true" class="form-inline head-left-inline" label-width="80px">
              <div class="row-4">
                <el-form-item label="H-L-4-1">
                  <el-select 
                    v-model="tyreTemp.H_L_4_1.sensor" 
                    filterable 
                    clearable
                    placeholder="Select Tyre"
                    @change="changeOption">
                    <el-option 
                      v-for="item in tyreList"
                      :key="item"
                      :label="item" 
                      :value="item"
                      >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="H-L-4-2">
                  <el-select 
                    v-model="tyreTemp.H_L_4_2.sensor" 
                    filterable 
                    clearable
                    placeholder="Select Tyre"
                    @change="changeOption">
                    <el-option 
                      v-for="item in tyreList"
                      :key="item"
                      :label="item" 
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              
              <div class="row-5">
                <el-form-item label="H-L-5-1">
                  <el-select 
                    v-model="tyreTemp.H_L_5_1.sensor" 
                    filterable 
                    clearable
                    placeholder="Select Tyre"
                    @change="changeOption">
                    <el-option 
                      v-for="item in tyreList"
                      :key="item"
                      :label="item" 
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="H-L-5-2">
                  <el-select 
                    v-model="tyreTemp.H_L_5_2.sensor" 
                    filterable
                    clearable 
                    placeholder="Select Tyre"
                    @change="changeOption">
                    <el-option 
                      v-for="item in tyreList"
                      :key="item"
                      :label="item" 
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>

              <div class="row-6">
                <el-form-item label="H-L-6-1">
                  <el-select 
                    v-model="tyreTemp.H_L_6_1.sensor" 
                    filterable
                    clearable 
                    placeholder="Select Tyre"
                    @change="changeOption">
                    <el-option 
                      v-for="item in tyreList"
                      :key="item"
                      :label="item" 
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="H-L-6-2">
                  <el-select 
                    v-model="tyreTemp.H_L_6_2.sensor" 
                    filterable 
                    clearable
                    placeholder="Select Tyre"
                    @change="changeOption">
                    <el-option 
                      v-for="item in tyreList"
                      :key="item"
                      :label="item" 
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                
              </div>

              <div>
                <el-button type="primary" @click="onSubmit" class="submitBtn">
                  Submit
                </el-button>
              </div>
            </el-form>
            
          </el-col>
          <el-col :span="4">
            <div class="car">
              <div class="row row-4">
                <img src="~assets/img/tire.png" :style="{ opacity: tyreTemp.H_L_4_1.sensor ? 1 : 0}">
                <img src="~assets/img/tire.png" :style="{ opacity: tyreTemp.H_L_4_2.sensor ? 0.6 : 0}">
                <div class="space"></div>
                <img src="~assets/img/tire.png" :style="{ opacity: tyreTemp.H_R_4_1.sensor ? 0.6 : 0}">
                <img src="~assets/img/tire.png" :style="{ opacity: tyreTemp.H_R_4_2.sensor ? 1 : 0}">
              </div>
              <div class="row row-5">
                <img src="~assets/img/tire.png" :style="{ opacity: tyreTemp.H_L_5_1.sensor ? 1 : 0}">
                <img src="~assets/img/tire.png" :style="{ opacity: tyreTemp.H_L_5_2.sensor ? 0.6 : 0}">
                <div class="space"></div>
                <img src="~assets/img/tire.png" :style="{ opacity: tyreTemp.H_R_5_1.sensor ? 0.6 : 0}">
                <img src="~assets/img/tire.png" :style="{ opacity: tyreTemp.H_R_5_2.sensor ? 1 : 0}">
              </div>
              <div class="row row-6">
                <img src="~assets/img/tire.png" :style="{ opacity: tyreTemp.H_L_6_1.sensor ? 1 : 0}">
                <img src="~assets/img/tire.png" :style="{ opacity: tyreTemp.H_L_6_2.sensor ? 0.6 : 0}">
                <div class="space"></div>
                <img src="~assets/img/tire.png" :style="{ opacity: tyreTemp.H_R_6_1.sensor ? 0.6 : 0}">
                <img src="~assets/img/tire.png" :style="{ opacity: tyreTemp.H_R_6_2.sensor ? 1 : 0}">
              </div>
            </div>
        </el-col>
          <el-col :span="10">
            <el-form ref="headRightForm" :inline="true" class="form-inline head-right-inline"  label-width="80px">
              <div class="row-4">
                <el-form-item label="H-R-4-1">
                  <el-select 
                    v-model="tyreTemp.H_R_4_1.sensor" 
                    filterable 
                    clearable
                    placeholder="Select Tyre"
                    @change="changeOption">
                    <el-option 
                      v-for="item in tyreList"
                      :key="item"
                      :label="item" 
                      :value="item"
                      >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="H-R-4-2">
                  <el-select 
                    v-model="tyreTemp.H_R_4_2.sensor" 
                    filterable
                    clearable 
                    placeholder="Select Tyre"
                    @change="changeOption">
                    <el-option 
                      v-for="item in tyreList"
                      :key="item"
                      :label="item" 
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              
              <div class="row-5">
                <el-form-item label="H-R-5-1">
                  <el-select 
                    v-model="tyreTemp.H_R_5_1.sensor" 
                    filterable
                    clearable 
                    placeholder="Select Tyre"
                    @change="changeOption">
                    <el-option 
                      v-for="item in tyreList"
                      :key="item"
                      :label="item" 
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="H-R-5-2">
                  <el-select 
                    v-model="tyreTemp.H_R_5_2.sensor" 
                    filterable 
                    clearable
                    placeholder="Select Tyre"
                    @change="changeOption">
                    <el-option 
                      v-for="item in tyreList"
                      :key="item"
                      :label="item" 
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>

              <div class="row-6">
                <el-form-item label="H-R-6-1">
                  <el-select 
                    v-model="tyreTemp.H_R_6_1.sensor" 
                    filterable
                    clearable 
                    placeholder="Select Tyre"
                    @change="changeOption">
                    <el-option 
                      v-for="item in tyreList"
                      :key="item"
                      :label="item" 
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="H-R-6-2">
                  <el-select 
                    v-model="tyreTemp.H_R_6_2.sensor" 
                    filterable 
                    clearable
                    placeholder="Select Tyre"
                    @change="changeOption">
                    <el-option 
                      v-for="item in tyreList"
                      :key="item"
                      :label="item" 
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-form>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { getIdleTyre } from "network/device";
  import { updateVehicle} from "network/vehicle";

  export default {
    name: "BindTrailer",
    data() {
      return {
        tyreList: [],
        vehicle_plate: "",
        vehicle_id: "",
        gateway: "",
        tyreTemp: {
          H_L_4_1: {
            sensor: "",
            value: ""
          },
          H_L_4_2: {
            sensor: "",
            value: ""
          },
          H_L_5_1: {
            sensor: "",
            value: ""
          },
          H_L_5_2: {
            sensor: "",
            value: ""
          },
          H_L_6_1: {
            sensor: "",
            value: ""
          },
          H_L_6_2: {
            sensor: "",
            value: ""
          },
          H_R_4_1: {
            sensor: "",
            value: ""
          },
          H_R_4_2: {
            sensor: "",
            value: ""
          },
          H_R_5_1: {
            sensor: "",
            value: ""
          },
          H_R_5_2: {
            sensor: "",
            value: ""
          },
          H_R_6_1: {
            sensor: "",
            value: ""
          },
          H_R_6_2: {
            sensor: "",
            value: ""
          },
        }
      }
    },
    created() {
      this.getTyreList()
    },
    mounted() {
      this.vehicle_plate = this.$route.query.plate
      this.vehicle_id = this.$route.query.vehicle_id
    },
    methods: {
      getTyreList() {
        getIdleTyre()
          .then((data) => {
            this.tyreList = data.data
          })
          .catch((err) => {
            this.$message.error("Interface error:get_idle_tyre");
          });
      },
      changeOption(option) {
        const values = Object.values(this.tyreTemp).map(obj => obj.sensor.trim());

        const hasDuplicate = values.some((val, i) => val !== "" && values.indexOf(val) !== i);
        if (hasDuplicate) {
          this.$message.error(`${option} has been selected`);
        }
      },
      onSubmit() {
        const values = Object.values(this.tyreTemp).map(obj => obj.sensor.trim());
        const hasDuplicate = values.some((val, i) => val !== "" && values.indexOf(val) !== i);

        if (hasDuplicate) {
          this.$message.error(`Tyre repeat selection`);
          return
        }
        
        const subData = {
          gateway_id: this.gateway,
          tyre_pressure_dic: this.tyreTemp
        }
        updateVehicle(this.vehicle_id, subData).then(data => {
          if (data.status === 200) {
            this.$message({
              message: "Updated Successfully.",
              type: "success",
            });
            this.$router.push({
              path: '/trailer'
            })
          }
        }) 
        .catch((err) => {
          this.$message.error("Interface error: update_vehicle");
        });
      }
    },
  }
</script>

<style scoped>
.bind h3 {
  font-size: 22px;
  font-weight: 400;
  color: #1f2f3d;
}
.bind .gatewayForm{
  margin-top: 70px;
}
.bind .head-left-inline {
  text-align: right;
}
.bind .head-right-inline {
  text-align: left;
}
.bind .form-inline .el-select {
  width: 120px;
}
.bind .form-inline .row-4{
  margin-top: 330px;
}
.bind .form-inline .row-5{
  margin-top: 4px;
}
.bind .form-inline .row-6{
  margin-top: 0px;
}
.bind .car{
  position: relative;
  width: 100%;
  height: 560px;
  background: url("~assets/img/bg_car_trail.png") no-repeat center;
}
.bind .car .row {
  display: flex;
  justify-content: center;
  text-align: center;
  line-height: 64px;
}
.bind .car .row-4{
  position: absolute;
  top: 56%;
  left: 0;
  right: 0;
}
.bind .car .row-5{
  position: absolute;
  top: 68%;
  left: 0;
  right: 0;
}
.bind .car .row-6{
  position: absolute;
  top: 80%;
  left: 0;
  right: 0;
}
.bind .car .space{
  display: inline-block;
  width: 62px;
}
.bind .submitBtn{
  margin-top: 50px;
}
</style>